import { observer } from 'mobx-react-lite';
import { StructuredText } from 'react-datocms';

import InputElement from '@/components/common/InputElement/InputElement';
import FilterButton from '@/components/menuV2/FilterButton/FilterButton';
import type { FilterSectionRecordModelType } from '@/models/api';
import { useStore } from '@/models/root-store';

import FilterSwitchButton from '../FilterSwitchButton/FilterSwitchButton';

interface IFilterSection {
  filter: FilterSectionRecordModelType;
  isFiltered: (key: string, value: string) => boolean;
  setFilter: (key: string, value: string) => void;
  setCurrentSelectedFilter: (key: string) => void;
  search?: boolean;
}

const FilterSection: React.FC<IFilterSection> = observer(
  ({ filter, isFiltered, setFilter, setCurrentSelectedFilter, search }) => {
    const {
      productStore: {
        filters: {
          selectedFilters: { isDisabled },
        },
      },
    } = useStore();
    const type = filter.filterType;

    switch (type) {
      case 'Button':
        return (
          <>
            <div className="grid grid-cols-2 gap-3 lg:grid-cols-1 xl:grid-cols-2">
              {filter?.values?.map((value: any) => (
                <FilterButton
                  key={value.id}
                  filter={value}
                  checked={isFiltered(value.key, value.value)}
                  disabled={
                    search ? isDisabled(value.key, value.data.value) : false
                  }
                  onChange={() => {
                    setFilter(value.key, value.value);
                    setCurrentSelectedFilter('filter');
                  }}
                />
              ))}
            </div>
          </>
        );
      case 'Switch':
        return (
          <div className="flex flex-col space-y-2">
            {filter?.values?.map((value: any) => (
              <FilterSwitchButton
                key={value.id}
                label={value.name}
                checked={isFiltered(value.key, value.value)}
                onChange={() => {
                  setFilter(value.key, value.value);
                  setCurrentSelectedFilter('filter');
                }}
                disabled={
                  search ? isDisabled(value.key, value.data.value) : false
                }
              />
            ))}
            <div className="font-interMedium text-xxs text-grey-dark">
              <StructuredText data={filter.tips} />
            </div>
          </div>
        );
      default:
        return (
          <div className="flex flex-col space-y-2">
            {filter?.values?.map((value: any) => (
              <InputElement
                value={value}
                key={value.id}
                label={value.name}
                type="checkbox"
                disabled={
                  search ? isDisabled(value.key, value.data.value) : false
                }
                checked={isFiltered(value.key, value.value)}
                onChange={() => {
                  setFilter(value.key, value.value);
                  setCurrentSelectedFilter('filter');
                }}
                search={search}
              />
            ))}
          </div>
        );
    }
  },
);

export default FilterSection;
